import React from "react";
import { createDevTools } from "@redux-devtools/core";
import { DockMonitor } from "@redux-devtools/dock-monitor";
import { InspectorMonitor } from "@redux-devtools/inspector-monitor";

let defaultIsVisible = false;

const ReduxDevTools = createDevTools(
  <DockMonitor
    toggleVisibilityKey="ctrl-h"
    changePositionKey="ctrl-q"
    defaultPosition="right"
    changeMonitorKey="ctrl-m"
    defaultIsVisible={defaultIsVisible}
  >
    <InspectorMonitor />
  </DockMonitor>
);

export default ReduxDevTools;
